export const CHECKOUT_URL = 'https://domotique-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offre'

export const PRODUCT_NAME = 'DOMOTIQUE PRO™'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/2aPYg3GxRqReH7PvKQ8S2G/ChatGPT-Image-14-ago-2026_-07_03_23-p.m..webp'

export const PRODUCT_ALT =
  'DOMOTIQUE PRO™ — coffret du système complet 6-en-1 pour apprendre, installer et maîtriser la domotique'

export const PRICE_FULL = '97 €'

export const PRICE_TODAY = '27 €'
